import { Component } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-confirm-dialog',
  standalone: false,
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
  title: string = 'Confirm';
  message: string = 'Are you sure you want to proceed?';
  confirmText: string = 'Confirm';
  confirmStatus: 'primary' | 'danger' | 'warning' | 'success' = 'primary';

  getSeverity(status: string): "success" | "info" | "warn" | "danger" | "secondary" | "contrast" | undefined {
    switch (status) {
      case 'danger':
        return 'danger';
      case 'warning':
        return 'warn';
      case 'success':
        return 'success';
      case 'info':
        return 'info';
      default:
        return 'secondary';
    }
  }

  close(result: boolean) {
    this.ref.close(result);
  }

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
    if (this.config.data) {
      this.title = this.config.data.title || this.title;
      this.message = this.config.data.message || this.message;
      this.confirmText = this.config.data.confirmText || this.confirmText;
      this.confirmStatus = this.config.data.confirmStatus || this.confirmStatus;
    }
  }

  cancel(): void {
    this.ref.close(false);
  }

  confirm(): void {
    this.ref.close(true);
  }
}
